import { Icon } from "@app/components/Icon"
import { Box, HStack, useRadio, useRadioGroup, Stack, chakra } from "@chakra-ui/react"
import React from "react"

export function CustomRadio(props) {
  const { ...radioProps } = props
  const { getInputProps, getCheckboxProps, htmlProps, getLabelProps } = useRadio(radioProps)

  return (
    <chakra.label {...htmlProps} cursor="pointer">
      <input {...getInputProps()} hidden />
      <Box {...getCheckboxProps()}>
        <Icon name={props.icon} width={10} height={10} {...getLabelProps()} />
      </Box>
    </chakra.label>
  )
}

export function ReviewAddStarRatingInput({ value, onChange }) {
  const [currentDisplayValue, setCurrentDisplayValue] = React.useState(0)

  const ratings = [{ value: "1" }, { value: "2" }, { value: "3" }, { value: "4" }, { value: "5" }]

  const handleChange = (value: string) => {
    //use form requires the event be structured like this
    onChange({ target: { type: "change", name: "rating", value: parseInt(value) } })
  }
  const hanldeHover = (value: string) => {
    setCurrentDisplayValue(parseInt(value))
  }
  const hanldeExit = () => {
    setCurrentDisplayValue(value)
  }

  const { getRadioProps, getRootProps } = useRadioGroup({
    defaultValue: "0",
    value: value.toString(),
    onChange: handleChange,
  })

  return (
    <Stack {...getRootProps()}>
      <HStack>
        {ratings.map(ratings => {
          return (
            <CustomRadio
              key={ratings.value}
              {...getRadioProps({ value: ratings.value })}
              icon={currentDisplayValue >= parseInt(ratings.value) ? "review-star-full" : "review-star-empty"}
              onMouseEnter={() => {
                hanldeHover(ratings.value)
              }}
              onMouseLeave={hanldeExit}
            />
          )
        })}
      </HStack>
    </Stack>
  )
}
